import React from 'react';
import { Box, Divider, Grid, Stack } from '@mui/material';
import RegisterUserForm, {
  initialValues as registerUserInitialValues,
} from '../../../auth/RegisterUser/RegisterUserForm';
import { MyButton, MyTypography } from '../../../common/components';
import AddExistingClinicUser from '../ClinicDetails/AddExistingClinicUser';
import { isEmpty } from 'lodash';
import { ROLE_PROVIDER } from '../../../auth/constants/Role';

export default function UserStep({
  control,
  errors,
  getValues,
  setValue,
  trigger,
  appendUser,
  removeUser,
  fieldsUser,
  existingUsers,
  setExistingUsers,
  addUserFromOtherClinicDialogVisible,
  setAddUserFromOtherClinicDialogVisible,
  watch
}) {
  return (
    <Grid item xs={12}>
      <MyTypography variant="subtitle1" sx={{ mb: 2 }}>
        You can add new users or import existing users into this clinic.
      </MyTypography>

      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
        <MyButton
          type="button"
          variant="contained"
          onClick={() => appendUser({ ...registerUserInitialValues })}
          fullWidth={false}
          sx={{ minWidth: 120 }}
        >
          Add User
        </MyButton>
        <MyButton
          type="button"
          variant="contained"
          onClick={() => setAddUserFromOtherClinicDialogVisible(true)}
          fullWidth={false}
          sx={{ minWidth: 180 }}
        >
          Import Existing User
        </MyButton>
      </Stack>

      <Divider sx={{ my: 3 }} />

      {addUserFromOtherClinicDialogVisible && (
        <AddExistingClinicUser
          existingUsers={existingUsers}
          setExistingUsers={setExistingUsers}
          appendUser={appendUser}
        />
      )}

      {fieldsUser.map((_item, index) => {
        const roleId = getValues(`users.${index}.role_id`);

        if (roleId === ROLE_PROVIDER.id) return null;

        return (
          <Box key={`box-users-${index}`} sx={{ mb: 4 }}>
            <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
              <MyTypography variant="h3">
                User Information
              </MyTypography>
              <Box sx={{ flexGrow: 1 }} />
              {index > -1 && (
                <MyButton
                  type="button"
                  variant="contained"
                  onClick={() => removeUser(index)}
                  fullWidth={false}
                >
                  Remove
                </MyButton>
              )}
            </Stack>

            <RegisterUserForm
              key={`users.${index}`}
              name={`users.${index}`}
              prefix={`users.${index}`}
              control={control}
              errors={errors}
              disabled={!isEmpty(getValues(`users.${index}.id`))}
              setValue={setValue}
              trigger={trigger}
              providers={getValues('providers')}
              permissions={[]}
              watch={watch}
            />
            <Divider sx={{ my: 3 }} />
          </Box>
        )
      })}
    </Grid>
  );
}
